module.exports = __webpack_public_path__ + "static/59-a5d8949634d11365005f76106ee70078.jpg";